(function($, Drupal) {
  Drupal.behaviors.betty_bot = {
    attach: function(context, settings) {
      const $betty_bot_open = $('#open-betty-bot', context);
      const $betty_bot_open_wrap = $('#trigger-betty-bot-wrap', context);
      const $betty_bot_close = $('#close-betty-bot', context);
      const $betty_bot_window = $('#betty-bot-window', context);
      const $betty_bot_download = $('#trigger-download', context);
      const $html = $('html');

      $betty_bot_open.once('open-betty-bot').on('click', function() {
        $betty_bot_open_wrap.addClass('active');
        $betty_bot_window.addClass('active');

        if ($(window).width() < 820) {
          $html.addClass('no-scroll');
        }
      });

      $betty_bot_download.once('download-betty-bot').on('click', function() {
        $('#downloadChat').trigger('click');
      });

      $betty_bot_close.once('close-betty-bot').on('click', function() {
        $betty_bot_open_wrap.removeClass('active');
        $betty_bot_window.removeClass('active');
        $html.removeClass('no-scroll');
      });
    }
  };
})(jQuery, Drupal);
